import trainingsHub from "@/views/workouts/v2/trainingsHub.vue"
import RunWorkout from "@/views/workouts/v2/runWorkout/runWorkout.vue"

export default [
  {
    path: "/workout/hub",
    name: "Workouts_v2",
    component: trainingsHub,
    meta: {
      navbarTitle: "Deine Workouts",
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
  {
    path: "/workout/summary",
    name: "WorkoutSummary",
    meta: {
      hideBottomNavigation: true,
      fullWidth: true,
    },
    component: () => import("@/views/workouts/v2/runWorkout/runWorkoutSummary.vue"),
  },
  {
    path: "/workout/run/split",
    name: "Workout_run",
    component: RunWorkout,
    meta: {
      navbarTitle: "Training",
      hideBottomNavigation: true,
      fullWidth: true,
    },
  },
]
